import React from 'react'
import { useDrag } from 'react-dnd';
import moment from 'moment'
const style = {
    border: '1px dashed gray',
    backgroundColor: 'white',
    padding: '0.1rem 0.5rem',
    marginRight: '1.5rem',
    marginBottom: '0.5rem',
    cursor: 'move',
    width:'100%'
};

export const buildBox = (item)=>{
  if(item.type=='date'){
    item.format = 'YYYY-MM-DD HH:mm'
    item.value = 'hello'//moment().format(item.format)

  }
  console.log('bb',item)
  return item
}

export const ConfigItemGroup =   (props) =>{
    const {item} = props
    const {name} = item
    const [{ isDragging }, drag] = useDrag(() => ({
        type: 'box',
        item:  item,
        end: (item, monitor) => {
            const dropResult = monitor.getDropResult();
            const delta = monitor.getDifferenceFromInitialOffset();
            if (item && dropResult) {
                //console.log(`You dropped ${item.name} `,item,dropResult,delta,monitor);
            }
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
            handlerId: monitor.getHandlerId(),
        }),
        isDragging:(monitor) =>{
          const delta = monitor.getDifferenceFromInitialOffset();
          //console.log("isDragging",monitor,delta)
        }
    }));
    const opacity = isDragging ? 0.4 : 1;
    return (<div ref={drag} role="Box" style={{ ...style, opacity }} data-testid={`box-${name}`}>
      {
        React.Children.map(props.children, (child) =>
          child
        )
      }
		</div>);
};

